import React, { useEffect, useState } from "react";
import Axios from "middleware/axiosInstance";
import { Link, useParams } from "react-router-dom";
import checkTik from "assets/images/wareHouse-icons/accept-check.svg";
import ButtonComponent from "components/Form/ButtonComponent";
import Loading from "layouts/Loading/Loading";

const ShowPersonDetails = () => {
  // start react router url params
  const UrlParams = useParams();
  const personId = UrlParams.id;
  // end react router url params
  const [person, setPerson] = useState(null);

  const getPersonInfo = () => {
    Axios.get(`/people/${personId}`)
      .then((res) => {
        setPerson(res.data);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getPersonInfo();
  }, []);

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">جزییات شخص</h5>

        <div className="d-flex flex-row ">
          <Link to={`/warehouse/persons/edit/${personId}`}>
            <ButtonComponent value="ویرایش" />
          </Link>
          <Link to="/warehouse/persons">
            <button className="bi-custom-button btn-sm">بازگشت</button>
          </Link>
        </div>
        {person ? (
          <div className="d-flex flex-column w-100">
            <h5 className="me-3 mt-2">
              <img
                width={25}
                src={checkTik}
                className="ms-1"
                alt=""
                srcset=""
              />
              مشخصات فردی
              {` ${person.name} ${person.family} `}
            </h5>
            <table className="bi-table-style w-100">
              <thead>
                <tr>
                  <th>نام</th>
                  <th>نام خانوادگی</th>
                  <th>
                    {person.type_person === "legal" ? "شناسه ملی" : "کد ملی"}
                  </th>
                  <th>تاریخ تولد</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{person.name || "- - -"}</td>
                  <td>{person.family || "- - -"}</td>
                  <td>
                    {person.type_person === "legal"
                      ? person.shenaseh_melli
                      : person.national_code || "- - -"}
                  </td>
                  <td>{person.birth_day || "- - -"}</td>
                </tr>
              </tbody>
            </table>
            <h5 className="me-3 mt-4">
              <img
                width={25}
                src={checkTik}
                className="ms-1"
                alt=""
                srcset=""
              />
              اطلاعات تماس
            </h5>
            <table className="bi-table-style w-100">
              <thead>
                <tr>
                  <th>شماره همراه</th>
                  <th>شماره ثابت</th>
                  <th>نام شرکت</th>
                  <th>آدرس ایمیل</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{person.cellular_phone || "- - -"}</td>
                  <td>{person.phone || "- - -"}</td>
                  <td>{person.company_name || "- - -"}</td>
                  <td>{person.email || "- - -"}</td>
                </tr>
              </tbody>
            </table>
            <h5 className="me-3 mt-4">
              <img
                width={25}
                src={checkTik}
                className="ms-1"
                alt=""
                srcset=""
              />
              آدرس
            </h5>
            <table className="bi-table-style w-100">
              <thead>
                <tr>
                  <th>استان</th>
                  <th>شهر</th>
                  <th>آدرس</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{person.province_name || "- - -"}</td>
                  <td>{person.city_name || "- - -"}</td>
                  <td>{person.address || "- - -"}</td>
                </tr>
              </tbody>
            </table>

            <h5 className="me-3 mt-4 ">
              <img
                width={25}
                src={checkTik}
                className="ms-1"
                alt=""
                srcset=""
              />
              سایر مشخصات
            </h5>
            <table className="bi-table-style w-100">
              <thead>
                <tr>
                  <th>نوع </th>
                  <th>مراودات</th>
                  <th>گروه</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{person.type_person === "legal" ? "حقوقی" : "حقیقی"}</td>
                  <td>
                    {person.moravedat === "moshtari"
                      ? "مشتری"
                      : person.moravedat === "tamin_konande"
                      ? "تامین کننده"
                      : person.moravedat === "karkonan"
                      ? "کارکنان"
                      : person.moravedat === "vaseteh"
                      ? "واسطه"
                      : "- - -"}
                  </td>
                  <td>{person.group_name || "vaseteh"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};
export default ShowPersonDetails;
